import LogoImg from "@/assets/logo.svg";
import "./styles.scss";
import { ImageLazy } from "@/components/imageLazy";
import { useTrackAccessSection } from "@/hooks/useTrackAccessSection";

export const Footer = () => {
  useTrackAccessSection(".footer", "footer");

  return (
    <div className="footer">
      <div className="footer-wrapper">
        <div className="footer-wrapper-content_info_company">
          <div className="footer-wrapper-content_info_company-logo">
            <ImageLazy
              src={LogoImg}
              alt="logo"
              className="footer-wrapper-content_info_company-img"
            />
          </div>

          <p className="footer-wrapper-content_info_company-info">
            Criando soluções inovadoras para fazer o seu provedor decolar.
          </p>

          <div className="footer-wrapper-content_info_company-sites">
            <a
              href="https://instagram.com/provenduz"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-wrapper-content_info_company-sites-icon"
            >
              <i className="bx bxl-instagram"></i>
            </a>
            <a
              href="mailto:contato@provenduz.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-wrapper-content_info_company-sites-icon"
            >
              <i className="bx bxl-gmail"></i>
            </a>
          </div>
        </div>

        <div className="footer-wrapper-terms">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://termos-e-politicas.provenduz.com.br/"
            className="footer-wrapper-terms-link"
          >
            Termos e políticas de privacidade
          </a>
        </div>
      </div>
    </div>
  );
};
